module.exports = __webpack_public_path__ + "static/media/malaysialog.23a13c65.png";